import React from "react";
import ReactMarkdown from "react-markdown"; // Re-add ReactMarkdown
import remarkGfm from "remark-gfm"; // Re-add remarkGfm
import { toArray as toEmojis } from "react-emoji-render";

export const MAX_MESSAGE_LENGTH = 3000;

export function formatMessageBody(body) {
  const bodyStr = typeof body === "string" ? body : body?.message || "";
  const cleanedBody = bodyStr.substring(0, Math.min(bodyStr.length, MAX_MESSAGE_LENGTH)).trim() || "";

  // Convert text to an array of strings and emoji components first
  const formattedComponents = toEmojis(cleanedBody);

  // Check if the result is just a single emoji component
  const isSingleEmoji = formattedComponents.length === 1 && typeof formattedComponents[0] !== "string";

  return {
    // Iterate through components: apply Markdown to strings, render emojis directly
    formattedBody: (
      <>
        {formattedComponents.map((component, index) => {
          if (typeof component === "string") {
            // Apply Markdown to string segments
            return (
              <ReactMarkdown
                key={index}
                remarkPlugins={[remarkGfm]}
                components={{
                  a: ({ ...props }) => <a target="_blank" rel="noopener noreferrer" {...props} />,
                  // Prevent ReactMarkdown from wrapping output in <p> for inline rendering
                  p: React.Fragment
                }}
              >
                {component}
              </ReactMarkdown>
            );
          } else {
            // Render emoji components directly
            return <React.Fragment key={index}>{component}</React.Fragment>;
          }
        })}
      </>
    ),
    multiline: cleanedBody.includes("\n"),
    monospace: cleanedBody.startsWith("`") && cleanedBody.endsWith("`"), // Keep this for potential styling
    emoji: isSingleEmoji
  };
}
